"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "falciano-del-massico": {
    "0a3f75aa": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "skipSearch": false
    }],
    "cambierti": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de748631": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "skipSearch": false
    }],
    "falciano-capo": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6ac4dca": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "skipSearch": false
    }],
    "falciano-selice": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f9b9eb2": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "skipSearch": false
    }],
    "quartone": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9d3d64db": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "skipSearch": false
    }],
    "sant-ilario": [{
      "hkey": "1c1c9cc1",
      "slug": "falciano-del-massico",
      "name": "Falciano del Massico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;